export function getTypeForm(state = false, action) {
  if (action.type === 'GET_TYPE_FORM') {
    return action.formType;
  }
  return state;
}
